<section class="section" [attr.aria-labelledby]="headingId">
  <header class="section__header">
    <div class="section__titles">
      <h2 class="section__heading" [id]="headingId">{{ heading() }}</h2>
      @if (description()) {
        <p class="section__description">{{ description() }}</p>
      }
    </div>
    <div class="section__actions">
      <ng-content select="[sectionActions]" />
    </div>
  </header>
  <div class="section__rows">
    <ng-content />
  </div>
</section>
